import session from "./session";

export default {
    getFiles(params) {
        return session.get("/v1/file_storage/", {params: params})
    },
};
